import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/global_styles.scss";
import store from "./store";

Vue.config.productionTip = false;
Vue.mixin({
  methods: {
    gExpandCursor: function () {
      if (this.$store.getters.getIsWebView) {
        var element = document.getElementById("cursor");
        element.style.transform = "scale(2) translate(-25%, -25%) ";
        element.style.backgroundColor = "#e6e6e6";
        document.body.style.cursor = "none";
      }
    },
    gShrinkCursor: function () {
      var element = document.getElementById("cursor");
      element.style.transform = "scale(1) translate(-50%, -50%)";
      element.style.backgroundColor = "#000";
      document.body.style.cursor = "default";
    },
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
